import { z } from 'zod';

import { LevelEnum } from '../../enums';
import { levelEnumValidator, uuidValidator } from '../../validators';

export const CreateSentenceSchema = z.object({
  level: levelEnumValidator.optional().default(LevelEnum.A1),
  text: z.string().min(1, 'Text cannot be empty'),
  translation: z.string().optional(),
  wordIds: z.array(uuidValidator).optional(),
});

export type ICreateSentenceDto = z.infer<typeof CreateSentenceSchema>;
